module.exports = __webpack_public_path__ + "static/media/screen_printing.9898e6b7.jpg";